export const cancelledByEnum = {
  ODE: "ODE",
  EXPERT: "EXPERT",
  ADMIN: "ADMIN"
};
